import { Injectable } from '@angular/core';

// Definimos una interfaz para que el código sea más robusto (opcional pero recomendado para BCP)
export interface Proyecto {
  titulo: string;
  categoria: string;
  imagen: string; // &lt;--- ¡IMPORTANTE! Agrega esta propiedad
  link: string;
}

@Injectable({ providedIn: 'root' })
export class ProyectosService {
  // Asegúrate de que todos tus objetos tengan la ruta correcta a la imagen
  private obras: Proyecto[] = [
    {
      titulo: 'Planta de Tratamiento de Agua Potable de Huachipa - SEDAPAL',
      categoria: 'agua',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881643/000348626M_d9zbo4.jpg',
      link: '/proyectos/planta-sedapal'
    },
    {
      titulo: 'Proyecto Alto Piura',
      categoria: 'agua',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881544/Tunel-AP_bcygh3.jpg',
      link: '/proyectos/alto-piura'
    },
    {
      titulo: 'Nuevo Aeropuerto Internacional Jorge Chávez - LAP',
      categoria: 'transporte',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881703/jorge-chavez_yiwfo9.jpg',
      link: '/proyectos/aeropuerto'
    },
    {
      titulo: 'Línea Amarilla - Vía Expresa Río Verde / Vía Parque Rímac',
      categoria: 'transporte',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881874/Desarrollo_Peruano_zzduss.jpg',
      link: '/proyectos/linea-amarilla'
    },
    {
      titulo: 'Metro de Lima - Línea 2',
      categoria: 'transporte',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881783/METRO-2-DE-LIMA-1_epiiyj.jpg',
      link: '/proyectos/metro-lima'
    },
    {
      titulo: 'Laguna Huascacocha',
      categoria: 'mineria',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881907/proy-17052023155503-proyecto-de-derivacion-huascacocha-rimac_wipgpn.jpg',
      link: '/proyectos/laguna' 
    },
    {
      titulo: 'Carretera Lima - Canta',
      categoria: 'infraestructura',
      imagen: 'https://res.cloudinary.com/dg7wvqxcv/image/upload/v1766881942/carrete-lima-canta-construccion-peru_gyzotk.jpg',
      link: '/proyectos/carretera-lima'
    }
  ];

  getObras() {
    return this.obras;
  }

  getProyectosAleatorios(linkActual: string, cantidad: number = 2) {
    // 1. Filtramos para no mostrar el proyecto actual
    const filtrados = this.obras.filter(o => o.link !== linkActual);
    
    // 2. Barajamos el arreglo (Algoritmo simple de ordenación aleatoria)
    const aleatorios = filtrados.sort(() => Math.random() - 0.5);
    
    // 3. Devolvemos la cantidad solicitada (2 según tu imagen)
    return aleatorios.slice(0, cantidad);
  }
}
